if (!customElements.get('mbs-sticky-buy')) {
  customElements.define('mbs-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById(this.dataset.section);
      this.proxy = this.querySelector('button');
      this.price = this.querySelector('.mbs-sticky-buy__price');
      if (!this.root) return;
      this.image = this.querySelector('.mbs-sticky-buy__image');
      this.defaultImage = this.image?.dataset.fallbackSrc;
      try {
        this.variants = JSON.parse(this.root.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]')?.textContent || '[]');
      } catch { this.variants = []; }
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.onClick = () => {
        const button = this.sourceButton();
        if (!button || button.disabled || button.matches('.is-loading, .loading')) return;
        const form = button.closest('form');
        if (form && !form.checkValidity()) {
          button.scrollIntoView({block:'center', behavior:'smooth'});
          form.reportValidity();
          return;
        }
        button.click();
        this.schedule();
      };
      this.proxy.addEventListener('click', this.onClick);
      this.onGalleryLoad = (event) => {
        if (event.target.matches('[data-image-gallery-main] img')) this.schedule();
      };
      this.root.addEventListener('load', this.onGalleryLoad, true);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule);
      window.visualViewport?.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class','disabled','aria-disabled','aria-busy','value']});
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, {attributes:true, attributeFilter:['class']});
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.root);
      this.resizeObserver.observe(this);
      this.update();
    }
    sourceButton() {
      return this.root.querySelector(this.dataset.salesMode === 'standard' ? '#product-add-to-cart' : '.mbs-sales-cta[data-product-enquiry-open]');
    }
    update() {
      const button = this.sourceButton();
      if (!button) { this.setVisible(false); return; }
      const busy = button.matches('.is-loading, .loading') || button.getAttribute('aria-busy') === 'true';
      this.proxy.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true' || busy;
      this.proxy.textContent = button.textContent.trim();
      this.proxy.setAttribute('aria-busy', String(busy));
      const variantId = button.closest('form')?.querySelector('[name="id"]')?.value || this.root.querySelector('[data-mbs-enquiry-selection] input[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === variantId);
      const imageSource = variant?.featured_image?.src || this.defaultImage;
      if (this.image && imageSource) {
        const imageURL = new URL(imageSource, window.location.origin);
        const filename = imageURL.pathname.split('/').pop();
        const loadedImage = Array.from(this.root.querySelectorAll('[data-image-gallery-main] img')).find(image => {
          if (!image.complete || !image.naturalWidth || !image.currentSrc) return false;
          return new URL(image.currentSrc, window.location.origin).pathname.split('/').pop() === filename;
        });
        imageURL.searchParams.set('width', '112');
        const source = loadedImage?.currentSrc || imageURL.href;
        if (this.imageSource !== source) {
          this.image.src = source;
          this.imageSource = source;
        }
      }
      const price = this.root.querySelector('.mbs-pi-price-display__primary');
      const savings = this.root.querySelector('.mbs-pi-price-display__savings');
      const priceHTML = this.dataset.salesMode === 'quote' ? '' : price ? price.innerHTML + (savings && !savings.hidden ? savings.outerHTML : '') : '';
      if (this.priceSource !== priceHTML) {
        this.priceSource = priceHTML;
        this.price.innerHTML = priceHTML;
        const rrp = this.price.querySelector('.mbs-pi-price-display__compare s');
        if (rrp) rrp.textContent = rrp.textContent.trim().replace(/^RRP of\s+/, 'RRP ');
      }
      const rect = button.getBoundingClientRect();
      const desktop = window.matchMedia('(min-width:990px)').matches;
      const navigation = document.querySelector('mbs-header[data-desktop-fixed] .mbsh__navigation');
      const top = desktop && navigation ? Math.max(0, navigation.getBoundingClientRect().bottom) : 0;
      this.style.setProperty('--mbs-sticky-buy-top', `${top}px`);
      const blocked = document.querySelector('dialog[open], mbs-header[data-menu-open]') || document.body.classList.contains('cart-sidebar-show');
      const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
      this.setVisible(rect.width > 0 && rect.bottom <= top && !blocked && !keyboard);
    }
    setVisible(visible) {
      const previous = document.body.style.getPropertyValue('--mbs-sticky-buy-height');
      this.hidden = !visible;
      document.body.toggleAttribute('data-mbs-sticky-buy', visible);
      const bottomHeight = visible && !window.matchMedia('(min-width:990px)').matches ? this.getBoundingClientRect().height : 0;
      document.body.style.setProperty('--mbs-sticky-buy-height', `${bottomHeight}px`);
      if (previous !== document.body.style.getPropertyValue('--mbs-sticky-buy-height')) {
        window.dispatchEvent(new Event('mbs:sticky-buy-change'));
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.visualViewport?.removeEventListener('resize', this.schedule);
      this.observer?.disconnect();
      this.bodyObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.proxy?.removeEventListener('click', this.onClick);
      this.root?.removeEventListener('load', this.onGalleryLoad, true);
      this.setVisible(false);
    }
  });
}
